<template>
  <v-container class="container">
    <v-card>
      <v-card-title>Formulario de Egreso </v-card-title>
      <v-card-text>
        <v-divider />
        <v-form ref="form" v-model="valid"> 
        <div >
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="tipoReembolsoSelected"
                item-value="id"
                item-text="name"
                :rules="[required]"
                label="Tipo de rembolso"
                outlined
                :items="tiporeembolso"
                return-object
                dense
                @change="tipoReembolsoOnChange()"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="formEgreso.montopago"
                :rules="[
                  required,
                  (v) =>
                    /^[0-9]{1,12}$/.test(v) ||
                    'Debe ser un entero de hasta 12 caracteres',
                ]"
                type="Number"
                label="Monto a Pagar"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </div>
        <h5>Dato Electorales</h5>
        <v-divider />
        <div>
          <v-row>
            <v-col cols="4">
              <v-select
                v-model="tipoEleccionSelected"
                :items="tipoeleccions"
                item-value="id"
                item-text="name"
                label="Tipo Elección"
                outlined
                :rules="[required]"
                dense
                return-object
                @change="tipoElecionOnChange()"
              />
            </v-col>
            <v-col cols="4">
              <v-menu
                ref="fechaEleccion"
                v-model="formEgreso.dateEleccion"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
                dense
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                  :rules="[
                  (v) =>
                    formEgreso.tipoeleccion == 0 ||
                    !!v ||
                    'El campo es requerido cuando tipoegreso no es 0'
                  ]"
                    v-model="formEgreso.fechaeleccionsinformato"
                    label="Fecha de la Elección"
                    persistent-hint
                    append-icon="mdi-calendar"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formEgreso.fechaeleccionsinformato"
                  no-title
                  @input="formEgreso.dateEleccion = false"
                  dense
                ></v-date-picker> </v-menu
            ></v-col>
          </v-row>
        </div>
        <h5>Candidato o partido político</h5>
        <v-divider />
        <div>
          <v-row>
            <v-col cols="6">
              <v-row class="flex-nowrap">
                <v-col cols="8">
                  <v-text-field
                    :rules="[
                      required,
                      (v) =>
                        /^[0-9]{1,10}$/.test(v) ||
                        'Debe ser un entero de hasta 10 caracteres',
                    ]"
                    v-model="formEgreso.rut"
                    label="Rut"
                    type="Number"
                    outlined
                    dense
                  />
                </v-col>

                <v-col>
                  <v-text-field
                    :rules="[
                      required,
                      (v) =>
                        /^([0-9K]){1}$/.test(v.toUpperCase()) ||
                        'Debe ser 0-9, K',
                    ]"
                    v-model="formEgreso.dv"
                    label="DV"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :rules="[
                  required,
                  (v) => v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                ]"
                v-model="formEgreso.nombre"
                label="Nombre"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                :rules="[
                  required,
                  (v) => v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                ]"
                v-model="formEgreso.apellidopaterno"
                label="Rs o apellido paterno"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
              :rules="[

                  (v) => v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                ]"
                v-model="formEgreso.apellidomaterno"
                label="Apellido materno"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </div>
        <h5>Beneficiario</h5>
        <v-divider />
        <div>
          <v-row>
            <v-col cols="6">
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    v-model="formEgreso.rutbeneficiario"
                    :rules="[required, v => /^[0-9]{1,10}$/.test(v) || 'Debe ser un entero de hasta 10 caracteres']"
                    label="Rut beneficiario"
                    type="Number"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="formEgreso.dvbeneficiario"
                    :rules="[
                      required,
                      (v) =>
                        /^([0-9K]){1}$/.test(v.toUpperCase()) ||
                        'Debe ser 0-9, K',
                    ]"
                    label="DV"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-select
              :rules="[
                  required
                ]"
                v-model="formEgreso.idsexobeneficiario"
                :items="sexos"
                item-text="name"
                item-value="id"
                label="Sexo"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
              :rules="[
                  (v) => v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                ]"
                v-model="formEgreso.nombrebeneficiario"
                label="Nombre beneficiario"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
              :rules="[
                  required,
                  (v) => v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                ]"
                v-model="formEgreso.apellidopaternobeneficiario"
                label="Razon o Apellido Paterno"
                outlined
                dense
              />
            </v-col>
            
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
              :rules="[
                  (v) => v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                ]"
                v-model="formEgreso.apellidomaternobeneficiario"
                label="Apellido materno"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
              :rules="[required]"
                v-model="formEgreso.idcorreoelectronico"
                :items="tipoCorreoElectronicos"
                item-text="name"
                label="Tipo correo electronico"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                :rules="[
                  required,
                  (v) =>
                    /^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,4}$/.test(v) ||
                    'Ingrese un correo electrónico válido',
                ]"
                v-model="formEgreso.correoelectronico"
                label="Correo electronico"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="formEgreso.telefono"
                :rules="[
                  (v) =>
                    /^[0-9]{1,11}$/.test(v) ||
                    'Debe ser un entero de hasta 11 caracteres',
                ]"
                type="Number"
                label="Telefono"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </div>
        <h5>Dirección del beneficiario</h5>
        <v-divider />
        <div>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                :rules="[required]"
                v-model="formEgreso.codigocomuna"
                label="comuna"
                outlined
                :items="comunas"
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="formEgreso.direcciontipocalle"
                :items="tipoDeCalle"
                :rules="[required]"
                item-text
                label="Dirección tipo de calle"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="formEgreso.direccioncalle"
                :rules="[
                  required,
                  (v) => v.length <= 55 || 'Debe ser de hasta 55 caracteres',
                ]"
                label="Nombre calle"
                outlined
                dense
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="formEgreso.direccionnumero"
                :rules="[v => v.length <= 15 || 'Debe ser de hasta 15 caracteres']"
                type="Number"
                label="Numero Dirección"
                outlined
                dense
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="formEgreso.direcciondepto"
                :rules="[v => v.length <= 15 || 'Debe ser de hasta 15 caracteres']"
                label="oficina/depto"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </div>
        <h5>Cuenta del benificiario</h5>
        <v-divider />
        <div>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="formEgreso.bancopagosbif"
                :items="tipoDeBancos"
                item-value="id"
                item-text="name"
                label="Seleccione Banco"
                :rules="[required]"
                outlined
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="formEgreso.tipocuentapago"
                :items="tipoDeCuentaPagos"
                label="Tipo de cuenta pago"
                :rules="[required]"
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                :rules="[required, v => /^([0-9]{1,12})$/.test(v) || 'Debe ser un entero de hasta 12 caracteres']"
                v-model="formEgreso.numerocuentapago"
                label="Numero de cuenta"
                outlined
                type="Number"
              />
            </v-col>
          </v-row>
        </div>
        <div>
          <v-row>
            <v-col cols="6">
              <v-btn @click="clearData()" class="mr-2">Borrar campos</v-btn>
            </v-col>
            <v-col cols="6" d-flex class="justify-right">
              <v-btn :disabled="!validFormBtn" color="primary" @click="sendEgreso()"
                >Enviar Egreso
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import comunas from "@/util/comunas";
import { EgresosService } from "../../util/Api/Egresos/calls";
import { Loading } from 'element-ui'
import Swal from "sweetalert2"
import {  mapGetters } from "vuex"
export default {
  name: "EgresoComponents",
  data() {
    return {
      valid:null,
      required: (v) => !!v || "El campo es requerido",
      comunas: [],
      tipoDeCalle: ["CALLE", "AVENIDA", "PASAJE"],
      tipoeleccions: [
        { id: 0, name: "Sin Elección" },
        { id: 1, name: "Presidente" },
        { id: 2, name: "Senadores" },
        { id: 3, name: "Diputados" },
        { id: 4, name: "Alcaldes" },
        { id: 5, name: "Concejales" },
        { id: 6, name: "Consejeros" },
        { id: 7, name: "plebiscito " },
        { id: 8, name: "Gore " },
        { id: 9, name: "Consejero Constitucional" },
      ],
      tiporeembolso: [
        {
          id: 1,
          name: "ANTICIPO",
        },
        {
          id: 2,
          name: "REEMBOLSO CANDIDATO",
        },
        {
          id: 3,
          name: "DIPUTADO",
        },
        {
          id: 4,
          name: "REEMBOLSO REMANENTE",
        },
        {
          id: 5,
          name: "REEMBOLSO INST.FINANCIERA",
        },
        {
          id: 6,
          name: "REEMBOLSO PARTIDO",
        },
        {
          id: 7,
          name: "REEMBOLSO COMPENSATORIO",
        },
        {
          id: 8,
          name: "FINANCIAMIENTO PERMANENTE PARTIDOS POLÍTICOS",
        },
        {
          id: 8,
          name: "REEMBOLSO CANDIDATA ELECTA",
        },
      ],
      tipoCorreoElectronicos: ["CONTACTO", "OTRO"],
      sexos: [
        { id: 1, name: "FEMENINO" },
        { id: 2, name: "MASCULINO" },
        { id: -1, name: "INDEFINIDO" },
      ],
      tipoDeCuentaPagos: ["CUENTA_CORRIENTE", "CUENTA_AHORRO", "CUENTA_VISTA"],
      tipoDeBancos: [
        { id: 1, name: "Banco de Chile" },
        { id: 9, name: "Banco Internacional" },
        { id: 14, name: "Scotiabank" },
        { id: 16, name: "Banco de crédito e Inversiones" },
        { id: 28, name: "Banco BICE" },
        { id: 31, name: "HSBC Bank Chile" },
        { id: 37, name: "Banco Santander Chile" },
        { id: 39, name: "Itaú CorpBanca" },
        { id: 49, name: "Banco Security" },
        { id: 51, name: "Banco Falabella" },
        { id: 53, name: "Banco Ripley" },
        { id: 54, name: "Rabobank Chile" },
        { id: 55, name: "Banco Consorcio" },
        { id: 56, name: "Banco Penta" },
        { id: 504, name: "Banco Bilbao Vizcaya Argentaria Chile (BBVA)" },
        { id: 59, name: "Banco BTG Pactual Chile" },
        { id: 12, name: "Banco Estado" },
        { id: 672, name: "Coopeuch" },
      ],
      tipoEleccionSelected:null,
      tipoReembolsoSelected:null,
      formEgreso: {
        fechaorigen:null,
        ambienteorigen: "TEST",
        idconceptopago: "FINANCIAMIENTO_PUBLICO_ELECTORAL",
        dateEleccion: false,
        tiporeembolso: null,
        nombrereembolso:null,
        montopago: "",
        fechaeleccionsinformato: null,
        tipoeleccion: null,
        nombreeleccion: null,
        tipopersona: null,
        rut: "",
        dv: "",
        nombre: "",
        apellidopaterno: "",
        apellidomaterno: "",
        tipopersonabeneficiario: null,
        rutbeneficiario: "",
        dvbeneficiario: "",
        nombrebeneficiario: "",
        apellidopaternobeneficiario: "",
        apellidomaternobeneficiario: "",
        idsexobeneficiario: null,
        idcorreoelectronico: "CONTACTO",
        correoelectronico: "",
        telefono: "",
        codigocomuna: null,
        direcciontipocalle: "",
        direccioncalle: "",
        direccionnumero: "",
        direcciondepto: "",
        idtipomoneda: 'CLP',
        bancopagosbif: null,
        tipocuentapago: null,
        numerocuentapago: null,
        agnotrimestre:null,
        numerotrimestre:null,
      },
    };
  },
  computed: {
    ...mapGetters(["getPerfil"]),

    validFormBtn() {
      return (
        this.formEgreso.tiporeembolso !== null &&
        this.formEgreso.montopago !== null &&
        this.formEgreso.fechaeleccionsinformato !== null &&
        this.formEgreso.rut !== null &&
        this.formEgreso.apellidopaterno !== "" &&
        this.formEgreso.rutbeneficiario !== null &&
        this.formEgreso.apellidopaternobeneficiario !== "" &&
        this.formEgreso.idsexobeneficiario !== null &&
        this.formEgreso.correoelectronico !== "" &&
        this.formEgreso.telefono !== null &&
        this.formEgreso.codigocomuna !== null &&
        this.formEgreso.numerocuentapago !== null
      );
    },
  },
  mounted() {
    console.log(this.comunas);
    this.comunas = comunas.comunas;
    this.loadingInstance.close()
  },
  methods: {
    clearData() {
      this.formEgreso = {
        tiporeembolso: null,
        dateEleccion: false,
        fechaeleccion: null,
        montopago: null,
        tipoeleccion: null,
        nombreeleccion: null,
        rutbeneficiario: null,
        dvBeneficiario: null,
        idsexobeneficiario: null,
        nombreBeneficiario: "",
        apellidopaternobeneficiario: "",
        apellidomaternobeneficiario: "",
        correoelectronico: "",
        rut: null,
        nombre: "",
        telefono: null,
        apellidopaterno: "",
        apellidomaterno: "",
        codigocomuna: null,
        direccioncalle: "",
        direccionnumero: null,
        direcciondepto: "",
        idtipomoneda: null,
        tipocuentapago: null,
        numerocuentapago: null,
      };
    },

    resetForm(){
      this.$refs.form.reset()
    },

    tipoElecionOnChange(){
      this.formEgreso.tipoeleccion= this.tipoEleccionSelected.id;
      this.formEgreso.nombreeleccion= this.tipoEleccionSelected.name;
    },
    tipoReembolsoOnChange(){
      this.formEgreso.tiporeembolso= this.tipoReembolsoSelected.id;
      this.formEgreso.nombrereembolso= this.tipoReembolsoSelected.name;
    },

    async sendEgreso() {
      try {
        const fechaorigren=new Date();
        this.loadingInstance = Loading.service({ fullscreen: true, text: 'Cargando..', background: 'rgba(0, 0, 0, 0.8)' })  
        
        if(this.formEgreso.tipoeleccion===0){
          this.formEgreso.agnotrimestre= fechaorigren.getFullYear();
          this.formEgreso.numerotrimestre= Math.ceil((fechaorigren.getMonth() + 1) / 3);
        }
        this.formEgreso.tipopersona =
        this.formEgreso.rut < 50000000 ? "NATURAL" : "JURIDICA";
        this.formEgreso.tipopersonabeneficiario =
          this.formEgreso.rutbeneficiario < 50000000 ? "NATURAL" : "JURIDICA";
        this.formEgreso.fechaorigen=fechaorigren.toISOString();
        this.formEgreso.fechaeleccion=this.formEgreso.fechaeleccionsinformato.replace(/-/g, '');
        this.formEgreso.direccionnumero=toString(this.formEgreso.direccionnumero)

        console.log('userPerfil',this.getPerfil);

      const body = {
        idusuario: this.getPerfil.id,
        idsubdireccion: this.getPerfil.subdireccion_id,
        data: [this.formEgreso],
      };

      const resp = await EgresosService.send(body);
      console.log('resp', resp);
      if (resp.statusCode != 200 && resp.statusCode != 201) {
        throw resp.msg
      }
      this.resetForm();
      this.loadingInstance.close();
      Swal.fire({ type: 'success', html: `Egreso Enviado`})
      } catch (error) {
        this.loadingInstance.close()
        console.log('error', error);
        Swal.fire({ type: 'error', html: `Error al enviar el egreso: ${JSON.stringify(error)}`})
      }

    },
  },
};
</script>

<style scoped>
.container {
  text-align: start !important;
}
</style>
